import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";
import type {
  AddContactChatReactionPayload,
  RemoveContactChatReactionPayload,
} from "@/dtos/ContactChat.dto";

export function useReactToContactChatMessage() {
  const queryClient = useQueryClient();

  const addReactionMutation = useMutation({
    mutationFn: async (payload: AddContactChatReactionPayload) => {
      const response = await Contact.addChatReaction(payload);
      return response.data.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["contact-chat-messages", variables.contactId],
      });
    },
  });

  const removeReactionMutation = useMutation({
    mutationFn: async (payload: RemoveContactChatReactionPayload) => {
      const response = await Contact.removeChatReaction(payload);
      return response.data.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["contact-chat-messages", variables.contactId],
      });
    },
  });

  return {
    addReaction: addReactionMutation.mutateAsync,
    removeReaction: removeReactionMutation.mutateAsync,
    isReacting: addReactionMutation.isPending,
    isRemovingReaction: removeReactionMutation.isPending,
  };
}
